import { Controller } from "@hotwired/stimulus"

// Rédaction d'un email avec variables : un clic sur une variable l'insère au curseur, dans
// l'objet ou le texte (le dernier champ actif) ; seules les variables de l'entité choisie sont proposées.
export default class extends Controller {
  static targets = ["field", "catalogue", "entity"]

  connect() {
    this.active = this.fieldTargets[this.fieldTargets.length - 1]
    this.entityChanged()
  }

  remember(event) { this.active = event.currentTarget }

  insert(event) {
    const field = this.active
    if (!field) return

    const variable = event.currentTarget.dataset.variable
    const start = field.selectionStart ?? field.value.length
    const end = field.selectionEnd ?? field.value.length
    field.value = `${field.value.slice(0, start)}${variable}${field.value.slice(end)}`
    field.focus()
    field.setSelectionRange(start + variable.length, start + variable.length)
    field.dispatchEvent(new Event("input", { bubbles: true }))
  }

  entityChanged() {
    if (!this.hasEntityTarget) return

    const entity = this.entityTarget.value
    this.catalogueTargets.forEach((element) => {
      element.hidden = entity !== "all" && element.dataset.entity !== entity
    })
  }
}
